import { nextJSProjectUtils } from "@editor/trpc/nextJSProject";
import { projectUtils } from "@editor/trpc/project";
import { v2ShopDeploymentUtils } from "@editor/trpc/v2ShopDeployment";

// NOTE (Cole, 2025-07-22): We can't export this from a tsx file so it's here, feel free to move it
export const invalidateResourcesRelatedToDeployment = () => {
  void projectUtils.invalidate();
  void v2ShopDeploymentUtils.findDeployments.invalidate();
  void nextJSProjectUtils.getPage.invalidate();
  void nextJSProjectUtils.listPages.invalidate();
};
